import { signOut } from '@/state/auth';

import { queryClient } from './api-provider';

type LogoutAppOptions = {
  replace?: boolean;
  navigateToLogin?: boolean;
  clearCache?: boolean;
};

export function logoutApp({
  replace = false,
  navigateToLogin = true,
  clearCache = true,
}: LogoutAppOptions = {}) {
  if (navigateToLogin) {
    // TODO WORKAROUND
    // @ts-expect-error react refresh si lamenterebbe se router venisse esportato
    window.router.navigate({ pathname: '/login' }, { replace });
  }
  if (clearCache) {
    queryClient.clear();
  }

  signOut();

  // window.location.href = '/login';
}
